import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import Modal from '../Modal/Modal';

const modalWrapperSx = (theme) => ({
  padding: '20px',
  '& h2': {
    ...theme.mixins.marketplaceModalTitleStyles,
  },
});

const modalTextWrapperSx = {
  marginTop: '20px',
  marginBottom: '40px',
  whiteSpace: 'pre-line',
};

const modalButtonWrapperSx = {
  marginTop: '24px',
};

/**
 * Modal component that displays a newsletter subscription form
 *
 * @component
 * @param {object} props
 * @param {boolean} props.isOpen - Controls whether the modal is displayed
 * @param {Function} props.onClose - Handler called when modal is closed
 * @param {Function} props.onManageDisableScrolling - Handler to manage scroll behavior when modal opens/closes
 * @returns {React.ReactNode} A modal displaying a newsletter subscription form
 */

const NewsletterSubscribedModal = ({ isOpen, onClose, onManageDisableScrolling }) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      id="NewsletterSubscribeModal"
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <Box sx={modalWrapperSx}>
        <FormattedMessage id="Page.newsletterModal.title" tagName="p" />
        <Box sx={modalTextWrapperSx}>
          <FormattedMessage id="Page.newsletterModal.text" />
        </Box>
        <Box sx={modalButtonWrapperSx}>
          <Button color="success" onClick={handleClose} size="large" variant="contained">
            <FormattedMessage id="Page.newsletterModal.buttonText" />
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default NewsletterSubscribedModal;
